export default "__VITE_ASSET__k0W5$1$b__"